import { render, staticRenderFns } from "./CombinationProperty.vue?vue&type=template&id=77d1e53d&scoped=true&"
import script from "./CombinationProperty.vue?vue&type=script&lang=ts&"
export * from "./CombinationProperty.vue?vue&type=script&lang=ts&"
import style0 from "./CombinationProperty.vue?vue&type=style&index=0&id=77d1e53d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d1e53d",
  null
  
)

export default component.exports